import * as Dialog from "@radix-ui/react-dialog";
import React from "react";
import { jt, t } from "ttag";

import RichText from "../../../common/RichText";
import { SVGIcon } from "../../../common/SVGIcon";

import styles from "./index.module.scss";

export const OrderNumberPopup = (props: {
    copy: string;
}): React.JSX.Element => {
    const dialogTrigger = (
        <Dialog.Trigger className={styles.trigger}>
            {t`Order Number`}
        </Dialog.Trigger>
    );
    return (
        <Dialog.Root>
            <p className={styles.root}>
                {jt`How do I find my ${dialogTrigger}?`}
            </p>
            <Dialog.Portal>
                <Dialog.Overlay className={styles.overlay} />
                <Dialog.Content className={styles.content}>
                    <Dialog.Close className={styles.close}>
                        <SVGIcon
                            name="closeIcon"
                            alt={t`Close`}
                            aria-hidden="true"
                        />
                    </Dialog.Close>
                    <RichText html={props.copy} />
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
